import type { FaireProductEntity } from "../../entity_types/product";

export const p_424s399atk: FaireProductEntity = {
  token: "p_424s399atk",
  type: "product",
  name: "In A Basket Mother's Day Card",
  brandToken: "b_6e2ihyb9",
  brandName: "Seas and Peas, LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/e8683ccb3bb79b53df61fa11079540a93a60102a928bd419f6d3f579dff230ac.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1d34bd4e5c09a97aa783b9bae78d97b358f52058e1fb2bf90d5339b54ee1e303.jpeg",
    "https://cdn.faire.com/fastly/a0fbc92eeb4d6bf1a28db9cfee5a8d66c77c344e9b77069ffd6b511c03e26920.jpeg",
  ],
  priceDollars: 2.25,
  description:
    "A funny, irreverent Mother's Day card for the mom that didn't leave you somewhere in a basket. Wholesale cards are sold as packs of six retail-ready cards.",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:06.928Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
